interface Point {
  latitude: number
  longitude: number
}
interface Points {
  start: Point
  end: Point
}

const radians = (value: number): number => (value * Math.PI) / 180

const distance = ({ start, end }: Points): string => {
  const radiusOfEarth = 3956

  const startLon = radians(start.longitude)
  const endLon = radians(end.longitude)
  const startLat = radians(start.latitude)
  const endLat = radians(end.latitude)

  // Haversine formula
  const lonDistance = endLon - startLon
  const latDistance = endLat - startLat
  const a =
    Math.pow(Math.sin(latDistance / 2), 2) +
    Math.cos(startLat) *
      Math.cos(endLat) *
      Math.pow(Math.sin(lonDistance / 2), 2)

  const c = 2 * Math.asin(Math.sqrt(a))

  return `${Math.round(c * radiusOfEarth * 10) / 10} miles`
}

export default distance
